<h2 mat-dialog-title>{{tituloTxt}}</h2>
<mat-dialog-content style="min-width: 400px; min-height: 100px;">
  <form [formGroup]="registerForm" (ngSubmit)="guardar()" class="example-form">
    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Nombre*</mat-label>
      <input
        formControlName="nombre"
        matInput
        placeholder="Nombre del plan"
        value=""
      />
      <mat-error>El nombre es requerido</mat-error>
    </mat-form-field>
    <input type="hidden" formControlName="id" value="" />

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Descripción</mat-label>
      <input
        formControlName="descripcion"
        matInput
        placeholder="Descripción del plan"
        value=""
      />
    </mat-form-field>

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Meses de vigencia*</mat-label>
      <input
        formControlName="mesesDeVigencia"
        matInput
        placeholder="Meses de vigencia"
        value=""
      />

    </mat-form-field>

    <mat-form-field appearance="outline" class="example-full-width">
      <mat-label>Valor*</mat-label>
      <input
        formControlName="valor"
        matInput
        placeholder="Valor"
        value=""
      />
    </mat-form-field>
  </form>


</mat-dialog-content>
<mat-dialog-actions>
  <button
    type="submit"
    mat-button
    mat-flat-button
    color="primary"
    (click)="guardar()"
    [disabled]="registerForm.invalid"
  >
    Guardar
  </button>
  <button mat-button mat-dialog-close="false">Cancelar</button>
</mat-dialog-actions>

<!-- mat-dialog-close='false' -->
